import { BaseMapPageContent } from "../../shared/components/base/page/BaseMapPageContent";
import { IMapRender } from "../../shared/components/definitions/map/IMapRender";
import { GanaderiaConfiguracionModal } from "../../shared/components/modulos/configuracion/ganaderia/modal/GanaderiaConfiguracionModal";
import { TareasSinAsignarModalRender } from "../../shared/components/modulos/rastro/modal/TareasSinAsignarModalRender";
import { AgriculturaMapRender } from "../../shared/components/modulos/terceros/finca/map/AgriculturaMapRender";
import { GanaderiaMapRender } from "../../shared/components/modulos/terceros/finca/map/GanaderiaMapRender";
import { HistoricoLoteModalRender } from "../../shared/components/modulos/pesaje/ganaderia/modal/HistoricoLoteModalRender";
import { RotacionPesajeVeterinariaModalRender } from "../../shared/components/modulos/pesaje/ganaderia/modal/RotacionPesajeVeterinariaModalRender";
import { serviceProvider } from "../../shared/comun/provider/ServiceProvider";
import { fx_createRotacionPesajeVeterinariaRequestEmpty } from "../../shared/modulos/pesaje/ganaderia/request/RotacionPesajeVeterinariaRequest";
import { fx_createTareaEjecucionGrpcService } from "../../shared/modulos/rastro/services/TareaEjecucionGrpcService";
import { ClienteFincaBaseResponse } from "../../shared/modulos/terceros/response/ClienteFincaBaseResponse";

export class FincaPage extends BaseMapPageContent {
  getMapRender(): IMapRender {
    const finca = serviceProvider.getFincaSelectedService().getRequired();
    if (finca.isAgricultura) {
      return new AgriculturaMapRender();
    }
    if (finca.isGanaderia) {
      // Bottom-sheet: RPV abre el formulario de evento con el potrero fijo como
      // origen; Histórico abre el modal del lote (el mapa queda intacto atrás).
      return new GanaderiaMapRender(
        (lote) => {
          const request = fx_createRotacionPesajeVeterinariaRequestEmpty();
          request.loteOrigenId = lote.id;
          new RotacionPesajeVeterinariaModalRender(request, lote).init();
        },
        (lote) => new HistoricoLoteModalRender(lote).init(),
      );
    }
    throw new Error("Finca sin módulo de mapa.");
  }

  render(
    pageContent: HTMLDivElement,
    secondSidebarWrapper: HTMLDivElement,
  ): void {
    super.render(pageContent, secondSidebarWrapper);

    // Finca de ganadería sin configurar: abre el modal obligatorio (no cancelable).
    const finca = serviceProvider.getFincaSelectedService().getRequired();
    if (finca.isGanaderia && !this._tieneConfigGanaderia(finca)) {
      new GanaderiaConfiguracionModal(finca, false).init();
    }

    // Ejecuciones de tarea sin clasificar: ofrece asignarlas (cancelable).
    fx_createTareaEjecucionGrpcService(finca.id)
      .getListAsync()
      .then((ejecuciones) => {
        const sinAsignar = ejecuciones.filter((e) => e.tareaId == null);
        if (sinAsignar.length > 0) {
          new TareasSinAsignarModalRender(
            sinAsignar,
            finca.id,
            finca.clienteId,
          ).init();
        }
      });
  }

  /** Hay configuración de ganadería si los cuatro óptimos están establecidos (> 0). */
  private _tieneConfigGanaderia(finca: ClienteFincaBaseResponse): boolean {
    return (
      finca.ganaderiaCrecimientoDiarioGr > 0 &&
      finca.ganaderiaDiasOcupacionOptimo > 0 &&
      finca.ganaderiaDiasDescansoOptimo > 0 &&
      finca.ganaderiaAnimalesXHectareaOptimo > 0
    );
  }
}
